import React from 'react';
import './Feature.css';

const Feature = ({ title, text }) => {
  return (
    <div className='about-feature-container'>
      <div className='about-title'>
        <div className='feature-heading-icon'>
        </div>
        <h1>{title}</h1>
      </div>
      <div className='feature-description'>
        <p>{text}</p>
      </div>
    </div>
  )
}

export default Feature
